import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import LocalizedLink from "../LocalizedLink";
import * as s from "./s.module.scss";
import Button from "../Button";
import Portal from "../Portal";
import { getStaticData } from "../../helperFunctions";
import StaticContent from "../../../content/global";

const CookieConsent = ({ locale }) => {
  const [cookie, setCookie] = useCookies(["cookieConsent"]);
  const initialCookieConsentState = () => {
    switch (cookie.cookieConsent) {
      case undefined:
        return true;
      case true:
        return true;
      case false:
        return false;
      default:
        return true;
    }
  };
  const [showCookie, setShowCookie] = useState(initialCookieConsentState());

  useEffect(() => {
    if (process.env.GATSBY_ACTIVE_ENV !== "production") {
      console.log("CookieConsent", cookie.cookieConsent)
    }
    if (cookie.cookieConsent === undefined) {
      setCookie("cookieConsent", true, { path: "/", maxAge: 2147483647 });
    }
  });

  return (
    <Portal>
      {showCookie && (
        <React.Fragment>
          <div className={s.overlay} />
          <div className={s.wrapper}>
            <div className={s.text}>
              {getStaticData(StaticContent.cookie_consent.by_continuing, locale).title}{" "}
              <LocalizedLink to="/policies/cookies">
                {getStaticData(StaticContent.cookie_consent.use_of_cookies, locale).title}
              </LocalizedLink>
            </div>
            <Button
              variant="primary"
              type="submit"
              onClick={() => {
                setShowCookie(false);
                if (cookie.cookieConsent) {
                  setCookie("cookieConsent", false, {
                    path: "/",
                    maxAge: 2147483647
                  });
                }
              }}
            >
              <span style={{ textTransform: "uppercase" }}>
                {getStaticData(StaticContent.accept, locale).title}
              </span>
            </Button>
          </div>
        </React.Fragment>
      )}
    </Portal>
  );
};

export default CookieConsent;
